<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Resources</h3>
            <p class="text-sm mb-0">Library of resources for sharing</p>
          </template>
          <div class="row card-body">
            <div class="col-lg-12" style="padding-bottom: 5px">
              <base-button @click.native="onNewCat()" type="success" size="sm" icon>
                <i class="text-white ni e-add"></i>
              </base-button>
              <base-button
                :disabled="!catid"
                @click.native="onEditCat()"
                class="edit"
                type="warning"
                size="sm"
                icon
              >
                <i class="text-white ni n-edit"></i>
              </base-button>
              <base-button
                :disabled="!catid"
                @click.native="onDeleteCat()"
                class="remove btn-link"
                type="danger"
                size="sm"
                icon
              >
                <i class="text-white ni e-remove"></i>
              </base-button>
            </div>
            <div class="col-lg-12">
              <el-select
                style="width: 100%"
                class="select-primary pagination-select"
                v-model="catid"
                placeholder="Category"
              >
                <el-option class="select-primary" label="Latest 100 added resources" value></el-option>
                <el-option
                  class="select-primary"
                  v-for="item in cats"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>

            <div class="col-lg-8">
              <div style="padding-top: 5px">
                <base-button :disabled="!catid" type="primary" @click.native="onNewRes">
                  <span class="btn-inner--icon">
                    <i class="ni e-add"></i>
                  </span>
                  New resource
                </base-button>
                <base-button type="info" @click.prevent="onRefresh" icon>
                  <span class="btn-inner--icon">
                    <i class="ni refresh-02"></i>
                  </span>Refresh
                </base-button>
              </div>
            </div>
            <div class="col-lg-4">
              <div style="padding-top: 5px">
                <base-input v-model="search" prepend-icon="fas fa-search" placeholder="Search..."></base-input>
              </div>
            </div>
            <div class="col-lg-12" v-for="item in ds" :key="item.id">
              <div style="padding-top: 5px">
                <div class="row">
                  <div class="col-lg-9">
                    <resource-item
                        :ref="item.id"
                        :title="item.title"
                        :description="item.description"
                        :files="item.files"
                        :cat="item.categoryname"
                      />
                  </div>
                  <div class="col-lg-3 col-12">
                    <base-button
                        @click.native="onCopy(item)"
                        class="edit"
                        type="default"
                        size="sm"
                        icon
                      >
                        <i class="text-white ni copy-2"></i>
                      </base-button>
                      <base-button
                        @click.native="onEditRes(item)"
                        class="edit"
                        type="warning"
                        size="sm"
                        icon
                      >
                        <i class="text-white ni n-edit"></i>
                      </base-button>
                      <base-button
                        @click.native="onDeleteRes(item.id)"
                        class="remove btn-link"
                        type="danger"
                        size="sm"
                        icon
                      >
                        <i class="text-white ni e-remove"></i>
                      </base-button>
                      <br />
                      <span style="font-size: 10px">{{item.created}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12"></div>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="catform" size="sm">
      <h6 slot="header" class="modal-title">Category action</h6>
      <validation-observer ref="catformvalid">
        <div class="row">
          <div class="col-lg-12">
            <base-input
              name="Name"
              v-model="cat.name"
              class="mb-3"
              label="Name"
              rules="required"
              placeholder="Name"
            ></base-input>
          </div>
        </div>
        <div class="text-center">
          <base-button type="primary" @click.prevent="onSaveCat()">Save and close</base-button>
        </div>
      </validation-observer>
    </modal>

    <modal :show.sync="resform" size="lg" bodyClasses="modalbody">
      <h6 slot="header" class="modal-title">Resource action</h6>
      <el-tabs type="card" v-model="activeTab" ref="tabs">
        <el-tab-pane label="Info" name="tab1">
          <validation-observer ref="resformvalid">
            <div class="row">
              <div class="col-lg-12">
                <base-input
                  name="Title"
                  rules="required"
                  v-model="res.title"
                  class="mb-3"
                  label="Title"
                  placeholder="Title"
                ></base-input>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="form-control-label">Description</label>
                  <textarea
                    rows="4"
                    class="form-control"
                    placeholder="Description"
                    label="Description"
                    v-model="res.description"
                  ></textarea>
                </div>
              </div>
            </div>
          </validation-observer>
          <div class="text-center">
            <base-button type="success" @click.prevent="onSaveRes(1)">Save and close</base-button>
            <base-button type="primary" @click.prevent="onSaveRes(2)">Save and go to files</base-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Files" name="tab2" :disabled="!res.id">
          <upload :sourcetype="3" :sourceId="res.id"></upload>
        </el-tab-pane>
      </el-tabs>
    </modal>
  </div>
</template>

<script>
import { fileUrl } from "../../../services/helper";
import VueClipboard from "vue-clipboard2";
import Upload from "../Upload";
import ResourceItem from "./ResourceItem";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Select, Option, Tabs, TabPane } from "element-ui";
import {
  GetCategories,
  GetResources,
  UpdateCategory,
  UpdateResource,
  CreateCategory,
  CreateResource,
  DeleteCategory,
  DeleteResource,
} from "../../../services/resources";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  validate,
} from "vee-validate/dist/vee-validate.full";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    Loading,
    ValidationObserver,
    ValidationProvider,
    Upload,
    ResourceItem,
  },
  data() {
    return {
      isLoading: false,
      catform: false,
      resform: false,
      cats: [],
      catid: "",
      cat: { id: "", name: "" },
      ress: [],
      resid: "",
      res: { id: "", categoryid: "", title: "", description: "" },
      activeTab: "tab1",
      search: "",
    };
  },
  computed: {
    ds() {
      return this.ress.filter(
        (c) =>
          !this.search ||
          (this.search !== "" &&
            c.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
      );
    },
  },
  methods: {
    getCategories() {
      this.isLoading = true;
      GetCategories().then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.cats = response.data.result;
        } else this.cats = [];
      });
    },
    getResources() {
      this.isLoading = true;
      GetResources(this.catid).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.ress = response.data.result;
        } else this.ress = [];
      });
    },

    onNewCat() {
      this.cat = { id: "", name: "" };
      this.catform = true;
    },
    onEditCat() {
      this.cat = Object.assign(
        {},
        this.cats.filter((c) => c.id === this.catid)[0]
      );
      this.catform = true;
    },
    onSaveCat() {
      this.$refs.catformvalid.validate().then((valid) => {
        if (valid) {
          if (this.cat.id) {
            this.isLoading = true;
            UpdateCategory(this.cat).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.catform = false;
                this.getCategories();
                this.notifyVue("success");
              } else {
                this.notifyVue("danger");
              }
            });
          } else {
            this.isLoading = true;
            CreateCategory(this.cat).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.catform = false;
                this.getCategories();
                this.notifyVue("success");
              } else {
                this.notifyVue("danger");
              }
            });
          }
        }
      });
    },

    onDeleteCat() {
      this.isLoading = true;
      DeleteCategory(this.catid).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.catform = false;
          this.catid = "";
          this.getCategories();
          this.notifyVue("success");
        } else {
          this.notifyVue("danger");
        }
      });
    },

    onNewRes() {
      this.res = { id: "", categoryid: "", title: "", description: "" };
      this.resform = true;
      this.activeTab = "tab1";
    },
    onEditRes(value) {
      this.res = Object.assign({}, value);
      this.resform = true;
      this.activeTab = "tab1";
    },
    onSaveRes(idx) {
      this.$refs.resformvalid.validate().then((valid) => {
        if (valid) {
          if (this.res.id) {
            this.isLoading = true;

            UpdateResource(this.res).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.resform = false;
                this.getResources(this.catid);
                this.notifyVue("success");
              } else {
                this.notifyVue("danger");
              }
            });
          } else {
            this.isLoading = true;
            this.res.categoryid = this.catid;
            CreateResource(this.res).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                if (idx === 1) this.resform = false;
                else {
                  this.notifyVue("success");
                  this.res.id = response.data.result;
                  this.activeTab = "tab2";
                }
                this.getResources(this.catid);
              } else {
                this.notifyVue("danger");
              }
            });
          }
        }
      });
    },
    onRefresh() {
      this.getResources(this.catid);
    },
    onDeleteRes(id) {
      this.isLoading = true;
      DeleteResource(id).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.resform = false;
          this.getResources();
          this.notifyVue("success");
        } else {
          this.notifyVue("danger");
        }
      });
    },
    onCopy(item) {
      let message = "";
      message =
        "Title:" +
        "\t" +
        item.title +
        "\n" +
        "Description:" +
        "\t" +
        item.description +
        "\n";
      let f = "";
      for (let i = 0; i < item.files.length; i++) {
        f +=
          "\n" +
          "File name:" +
          "\t" +
          item.files[i].name.substring(item.files[i].name.indexOf("_") + 1) +
          "\n" +
          "Download from:" +
          "\t" +
          fileUrl +
          item.files[i].name +
          "\n";
      }
      message += f;
      // message = this.$refs[item.id][0].$el.innerHTML;
      this.$copyText(message).then(
        (e) => {
          this.notifyVue("success", "Copied");
        },
        (e) => {
          this.notifyVue("danger", "Can not copy");
        }
      );
    },
  },
  mounted() {
    this.getCategories();
    this.getResources();
  },
  watch: {
    catid() {
      this.getResources(this.catid);
    },
  },
};
</script>

<style lang="scss">
.modalbody {
  min-height: 400px;
}
</style>